
import ReactDOM from 'react-dom/client';
import Landing from './components/Landing';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import './assets/css/index.css';
import './assets/css/scheme.css';
import { Environment as PloutousEnvironment, Ploutous } from '@ploutous/react-library';
import { i18nManager } from './i18n';

const router = createBrowserRouter([
    { path: "/", element: <Landing /> },
]);

Ploutous.init({
    serviceCode: "ploutous",
    businessCode: "ploutous",
    language: i18nManager.ActiveLanguage as any ?? "en",
    __base_url_do_not_set__: process.env.REACT_APP_PLOUTOUS_BASE_API_URL,
    environment: process.env.REACT_APP_ENV as PloutousEnvironment ?? PloutousEnvironment.staging,
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    //<React.StrictMode>
    <RouterProvider router={router} />
    //</React.StrictMode>
);

